module.exports = __webpack_public_path__ + "static/media/boink.7a62c926.mp3";